<script>
import _ from "lodash";
import IsEqualWithCustomizer from "@/mixins/IsEqualWithCustomizer";

export default {
    name: "VFormModified",
    props: {
        value: {},
        original: {},
    },
    mixins: [
        IsEqualWithCustomizer,
    ],
    data() {
        return {
            modified: null,
        };
    },
    computed: {
        wasModified() {
            return !_.isEqualWith(this.original, this.modified, this.isEqualWithCustomizer);
        },
    },
    watch: {
        modified(v) {
            this.$emit("update:modified", v);
        },
        original: {
            handler(v) {
                this.modified = _.cloneDeep(v);
            },
            immediate: true,
        },
        wasModified: {
            handler(v) {
                this.$emit("update:was-modified", v);
            },
            immediate: true,
        },
    },
}
</script>

<template>
    <v-form
        v-bind="$attrs"
        v-on="$listeners"
    >
        <slot v-bind="{modified, wasModified}"></slot>
    </v-form>
</template>

<style scoped lang="scss">

</style>
